<template>
  <ClientOnly>
    <highmap class="w-full h-full" :options="chartOptions" :map="mapOptions" />
  </ClientOnly>
</template>

<script setup lang="ts">
import departements from './departements.topo.json';
const mapOptions = ref({
  mapData: departements,
});

interface DepartementStat {
  code: string;
  name: string;
  count: number;
}

const props = withDefaults(
  defineProps<{
    eventsByDepartements?: DepartementStat[];
  }>(),
  {
    eventsByDepartements: () => [],
  },
);

const seriesData = computed<Array<[string, number]>>(() =>
  props.eventsByDepartements.map(({ code, count }) => [code, count]),
);
const router = useRouter();

const chartOptions = ref({
  title: {
    text: '',
  },
  accessibility: {
    enabled: false,
  },
  chart: {
    animation: true,
    map: departements,
    backgroundColor: 'transparent',
    margin: [0, 0, 0, 0],
  },
  subtitle: {
    text: '',
  },
  legend: {
    // itemStyle: {
    //   color: 'white',
    //   fontWeight: 'bold',
    // },
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colorAxis: {
    min: 0,
    minColor: '#1a1a1a',
    maxColor: '#d8ff3c',
  },
  mapNavigation: {
    enabled: true,
    buttonOptions: {
      alignTo: 'spacingBox',
    },
  },
  tooltip: {
    backgroundColor: '#121212',
    style: { color: '#fafaf7' },
    borderColor: '#262626',
    // @ts-expect-error Highcharts formatter `this` context is not typed
    formatter: function () {
      // @ts-expect-error Highcharts formatter `this` context is not typed
      if (this.point.value === 0) {
        // @ts-expect-error Highcharts formatter `this` context is not typed
        return `<b>${this.point.name}</b><br/> Aucune compétition`;
      }
      // @ts-expect-error Highcharts formatter `this` context is not typed
      return `<b>${this.point.name}</b><br/>${this.point.value} compétition(s)`;
    },
  },
  plotOptions: {
    // mappoint: {
    //   animation: false,
    // },
    series: {
      point: {
        events: {
          click: function () {
            router.push({
              name: 'index',
              query: {
                // @ts-expect-error Highcharts point `this` context is not typed
                selectedDepartements: this['hc-key'],
              },
            });
          },
        },
      },
    },
  },
  series: [
    {
      cursor: 'pointer',
      name: 'Compétitions',
      states: {
        hover: {
          color: '#d8ff3c',
        },
      },
      dataLabels: {
        enabled: true,
        format: '{point.name}',
      },
      allAreas: true,
      data: seriesData.value,
    },
  ],
});

// watch(
//   () => props.eventsByDepartements,
//   (newEventsByDepartements) => {
//     chartOptions.value.series[0].data = newEventsByDepartements;
//   },
//   { immediate: true },
// );
</script>
